var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/navigationmanager/parts/removegroup',["require", "exports", "common/parts"], function (require, exports, Parts) {
    "use strict";
    var RemoveGroup = (function (_super) {
        __extends(RemoveGroup, _super);
        function RemoveGroup(target) {
            _super.call(this);
            this._nodeAccessor = target;
        }
        RemoveGroup.prototype.process = function (symbol) {
            try {
                var currentNode = this._nodeAccessor();
                var tilesInGroup = Enumerable.From(currentNode.children).Where(function (_) { return _.groupId == symbol.key; }).ToArray();
                if (tilesInGroup && tilesInGroup.length > 0)
                    throw new Error("To be abble to detele group, please delete all tails from this group.");
                //parent.raw.groups.splice(parent.raw.groups.indexOf(symbol), 1);
                currentNode.groups.remove(symbol);
                this.output.call({});
            }
            catch (error) {
                this.error.call(error);
            }
        };
        return RemoveGroup;
    }(Parts.Part));
    return RemoveGroup;
});

